<template>
  <div class="content" id="contact">
    <div class="container">
      <div class="columns">
        <div class="column is">
          <h1 class="title">CONTACT US</h1>
          <div class="columns">
            <div class="column is-1 has-text-right">
              <span class="icon">
                <i class="fa fa-home"></i>
              </span>
            </div>
            <div class="column">
              <strong>Sigma Web</strong>
              <br>407, Suratwala Mark Plazzo
              <br>Hinjewadi Road, Hinjewadi
              <br>Pune 411014
            </div>
          </div>
          <div class="columns">
            <div class="column is-1 has-text-right">
              <span class="icon">
                <i class="fa fa-phone"></i>
              </span>
            </div>
            <div class="column">
              <a href="tel:918600996466">+91 860 099 6466</a>
            </div>
          </div>
          <div class="columns">
            <div class="column is-1 has-text-right">
              <span class="icon">
                <i class="fa fa-envelope"></i>
              </span>
            </div>
            <div class="column">
              <a href="mailto:tushar.kant@sigma-web.in">tushar.kant@sigma-web.in</a>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Name</label>
                <div class="control">
                  <input type="text" class="input" placeholder="required">
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Company</label>
                <div class="control">
                  <input type="text" class="input" placeholder="optional">
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Email</label>
                <div class="control">
                  <input type="email" class="input" placeholder="required">
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Mobile</label>
                <div class="control">
                  <input type="text" class="input" placeholder="required">
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Message</label>
                <div class="control">
                  <textarea class="textarea" placeholder="required"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a
      class="map"
      href="https://www.google.com/maps/place/Suratwala+Mark+Plazzo/@18.5903168,73.7461082,17z/data=!3m1!4b1!4m5!3m4!1s0x3bc2b9601aef9c3f:0xef3ffe4ecc151bbd!8m2!3d18.5903117!4d73.7482969"
    >
      <figure class="image">
        <img src="/Map.png" alt>
      </figure>
    </a>
  </div>
</template>
<script>
export default {};
</script>

<style lang="scss" scoped>
#contact {
  $padding: 64px;
  padding-top: $padding;
  margin-bottom: 0;

  .map {
    .image {
      margin: 0;
      margin-top: $padding;
    }
  }
}
</style>


